import * as React from 'react';
import parseISO from 'date-fns/parseISO';
import isSameDay from 'date-fns/isSameDay';
import { BookableDays } from './dateHelper';
import { BookableDatesResult } from '../../types';

export let noBookableDays: BookableDays = { firstBookableDate: null, earliestBookableDate: null };

function parseDay(day: string | null | undefined): Date | null {
    return day ? parseISO(day) : null;
}

export function bookableDaysOf(dates: BookableDatesResult | null | undefined): BookableDays {
    return dates
        ? {
              firstBookableDate: parseDay(dates.date),
              earliestBookableDate: parseDay(dates.earliestDate)
          }
        : noBookableDays;
}

function isSameOptionalDay(a: Date | null, b: Date | null): boolean {
    return a === null || b === null ? a === b : isSameDay(a, b);
}

function isSameBookableDays(a: BookableDays, b: BookableDays): boolean {
    return (
        isSameOptionalDay(a.firstBookableDate, b.firstBookableDate) &&
        isSameOptionalDay(a.earliestBookableDate, b.earliestBookableDate)
    );
}

// Every availability answer carries the order's bookable days. Normal orders get null days, the
// same as the screen starts with, so their first answer is shown at once. When an answer brings
// other days (an order with an extra booking day), the screen takes them over and this returns
// true until it has: the screen waits instead of showing a day it is about to leave.
export function useBookableDaysFrom(
    answer: { bookableDates?: BookableDatesResult | null } | undefined,
    bookableDays: BookableDays,
    setBookableDays: (bookableDays: BookableDays) => void
): boolean {
    let answerDays = answer ? bookableDaysOf(answer.bookableDates) : null;
    let isTakingOverBookableDays =
        answerDays !== null && !isSameBookableDays(bookableDays, answerDays);

    React.useEffect(() => {
        if (isTakingOverBookableDays) {
            setBookableDays(answerDays);
        }
    });

    return isTakingOverBookableDays;
}
